export default __webpack_public_path__ + "static/media/einzig_wahre_playeronly.c79dcdaa.png";